import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IMoveJob } from "@gtmhub/okrs/components/clone-okrs/clone-or-move.types";
import { RequestConfig } from "@webapp/core/abstracts/models/request-config.model";
import { BaseFacade } from "@webapp/core/abstracts/services/base-facade.service";
import { JobId } from "../../clone-or-move.types";
import { MoveOkrsApiService } from "./move-okrs-api.service";
import { MoveResourceRequest, MoveResourceRequestDTO } from "./move-okrs-facade.models";
import { MoveOkrsState } from "./move-okrs-state.service";

@Injectable({
  providedIn: "root",
})
export class MoveOkrsFacade extends BaseFacade<MoveResourceRequest, MoveResourceRequestDTO, MoveOkrsState, MoveOkrsApiService> {
  constructor(state: MoveOkrsState, api: MoveOkrsApiService) {
    super(state, api);
  }

  public scheduleMoveJob$(cloneRequest: MoveResourceRequest): Observable<JobId> {
    return this.post$(cloneRequest, {
      ...new RequestConfig(),
      url: this.apiService.getMoveJobsEndpoint(),
    });
  }

  public fetchMoveJobById$(target: JobId): Observable<IMoveJob> {
    return this.get$(null, {
      ...new RequestConfig(),
      url: `${this.apiService.getMoveJobsEndpoint()}/${target.id}`,
    });
  }
}
